// src/pages/HomePage.jsx
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Импортируем все наши секции
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Services from '../components/sections/Services';
import SpecialOfferSection from '../components/sections/SpecialOfferSection';
import Portfolio from '../components/sections/Portfolio';
import ReviewsSection from '../components/sections/ReviewsSection';
import ContactForm from '../components/sections/ContactForm';
import ReviewForm from '../components/sections/ReviewForm';

// Принимаем все нужные данные как пропсы от App.jsx
const HomePage = ({
  heroData,
  aboutData,
  servicesData,
  portfolioData,
  reviewsData,
  specialOfferData,
  onAddReviewClick,
  showReviewForm,
  isFormAnimating,
  handleCloseReviewForm,
  handleContentUpdate
}) => {

  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  useEffect(() => {
    const newTitle = t('seo.home.title');
    document.title = newTitle; // <-- Прямая команда JavaScript для смены заголовка
    console.log(`Заголовок документа принудительно обновлен на: "${newTitle}"`);


  }, [i18n.language, t]);

  // Структурированные данные для SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Dmitrij",
    "jobTitle": "programuotojas",
    "description": t('seo.home.description'),
    "url": "https://ignite-web.com",
    "image": "https://ignite-web.com/logo-mein.jpg",
    "sameAs": [
      "https://github.com/alexkio",
      "https://linkedin.com/in/alexkio"
    ],
    "knowsAbout": [
      "React.js",
      "PHP",
      "MySQL",
      "Docker",
      "JavaScript",
      "Web Development",
      "Full-Stack Development"
    ],
    "hasOccupation": {
      "@type": "Occupation",
      "name": "Pilnų darbų programuotojas",
      "description": "Profesionalus pilnų darbų programuotojas. Portfolio specializuojasi adaptyvių interneto svetainių kūrime naudojant React, PHP, MySQL ir Docker"
    }
  };

  return (
    <>
      {/* SEO мета-теги перенесены в public/index.html для совместимости с React 19 */}


      <Hero heroData={heroData} />
      <About aboutData={aboutData} />
      <Services servicesData={servicesData} />
      <SpecialOfferSection specialOfferData={specialOfferData} />
      <Portfolio portfolioData={portfolioData} />
      <ReviewsSection reviewsData={reviewsData} onAddReviewClick={onAddReviewClick} />


      <ContactForm />
    </>
  );
};

export default HomePage;